export const formatOfferTitle = (
    offerTitle: string,
    startHarbour: string,
    shipName: string,
    numOfNights: string,
): string => {
    const replacementMap: any = {
        '[xharbour]': startHarbour,
        '[xship]': shipName,
        '[xduration]': numOfNights,
    };
    return offerTitle.replace(/\[(([A-Za-z0-9#]+\s?))+]/g, function(matched: string) {
        return replacementMap[matched];
    });
};
